{
	"passwordUpdated": "Mot de passe mis à jour avec succès"
}
